var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.6924V18.5C4.25 19.0523 4.69772 19.5 5.25 19.5H10C10.5523 19.5 11 19.0523 11 18.5V16C11 15.4477 11.4477 15 12 15H13C13.5523 15 14 15.4477 14 16V18.5C14 19.0523 14.4477 19.5 15 19.5H19.75C20.3023 19.5 20.75 19.0523 20.75 18.5V11.6924C20.75 11.4106 20.6311 11.142 20.4227 10.9524L13.1727 4.36152C12.7913 4.01477 12.2087 4.01477 11.8273 4.36152L4.57733 10.9524C4.36885 11.142 4.25 11.4106 4.25 11.6924Z",
    fill: "#47494F",
    stroke: "#47494F"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.8368c04985f87c2755271f60c203b5d4.svg";